import Option from '../Option';

export default interface RefereeQuestion {
	text: string;
	type: RefereeQuestionTypes;
	mandatory: boolean;
	decimalPlaces?: number;
	minValue?: number;
	maxValue?: number;
	options?: Option<string>[];
}

export const createRefereeQuestion = (): RefereeQuestion => ({
	text: '',
	type: RefereeQuestionTypes.Text,
	mandatory: false,
	decimalPlaces: null,
	minValue: null,
	maxValue: null,
	options: null
});

// eslint-disable-next-line no-shadow
export enum RefereeQuestionTypes {
	Text = 'Text',
	Number = 'Number',
	Boolean = 'Boolean',
	Date = 'Date',
	CheckList = 'CheckList',
	RadioList = 'RadioList',
	Dropdown = 'Dropdown',
	Slider = 'Slider'
}
